export enum Types {
  GIFT_CARD = '2',
  COUPON = '1',
}
